/** Typography aligned with Ant Design Tooltip (ConfigProvider Inter token). */
export const APP_TOOLTIP_FONT_FAMILY = '"Inter", Helvetica, sans-serif';

export const APP_TOOLTIP_FONT_SIZE = '14px';

export const APP_TOOLTIP_LINE_HEIGHT = 1.5715;

export const APP_TOOLTIP_BODY_COLOR = 'rgba(255, 255, 255, 0.85)';

export const APP_TOOLTIP_TITLE_WEIGHT = 600;

export const APP_TOOLTIP_BODY_WEIGHT = 400;

export const appTooltipTypography = {
    fontFamily: APP_TOOLTIP_FONT_FAMILY,
    fontSize: APP_TOOLTIP_FONT_SIZE,
    lineHeight: APP_TOOLTIP_LINE_HEIGHT,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
};
